module.exports = __webpack_public_path__ + "img/qyglgw.7444d48.png";